import {Pipe, PipeTransform} from '@angular/core'
import {PropertyType, PropertyTypeMap} from '@sparbanken-syd/loan-backend'

@Pipe({
  name: 'propertyType'
})
export class PropertyTypePipe implements PipeTransform {
  transform(value: PropertyType) {
    return PropertyTypeMap.get(value) as string
  }

}
